import React, { useContext, useEffect } from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import { NextUIProvider } from '@nextui-org/react'
import PropTypes from 'prop-types'
import {
  themeClara,
  themeCoppel,
  themeInvex,
  themeReworth,
  themeUniq,
  themeLiverpool,
  themeSuburbia,
  themeFinsus,
  themeAlbo
} from './theme'

import { MainContext, MainContextProvider } from './context'
import { searchPromotionDataLayer } from './utils/gtmDatalayer'
// import Footer from './components/Footer'

import Fonts from './theme/fonts'

import { Route, Routes } from 'react-router-dom'
import { Home } from './pages/Home'
import { Venues } from './pages/Venues'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { appTheme } from './utils/appTheme'

const queryClient = new QueryClient()

const App = ({
  env,
  accentColor,
  lang,
  fontFamily,
  geo,
  uuid,
  fiid,
  gtm,
  skin,
  searchName,
  setSearchName
}) => {
  const { setConfigVars, setFilters, filters } = useContext(MainContext)

  useEffect(() => {
    if (searchName !== '') {
      setFilters({ ...filters, name: searchName })
    } else {
      setFilters({ ...filters, name: undefined })
    }

    if (searchName?.length > 0) {
      searchPromotionDataLayer(searchName, skin)
    }
  }, [searchName])

  useEffect(() => {
    setConfigVars({ env, geo, uuid, fiid, skin })
  }, [env, geo, uuid, fiid, skin])

  const handleSkin = (skin) => {
    if (skin?.includes('CLARA')) {
      return themeClara
    } else if (skin?.includes('COPPEL')) {
      return themeCoppel
    } else if (skin?.includes('INVEX')) {
      return themeInvex
    } else if (skin?.includes('UNIQ')) {
      return themeUniq
    } else if (skin?.includes('FINSUS')){
      return themeFinsus
    } else if (skin?.includes('LIVERPOOL')) {
      return themeLiverpool
    } else if (skin?.includes('SUBURBIA')) {
      return themeSuburbia
    } else if (skin?.includes('ALBO')) {
      return themeAlbo
    }   
    else {
      return themeReworth
    }
  }

  return (
    <ChakraProvider theme={handleSkin(skin)}>
      <NextUIProvider theme={appTheme}>
        <Fonts />
        <Routes>
          <Route
            path='/'
            element={
              <Home
                accentColor={accentColor}
                env={env}
                skin={skin}
                fontFamily={fontFamily}
                geo={geo}
                lang={lang}
                gtm={gtm}
                setSearchName={setSearchName}
              />
            }
          />
          <Route
            path='/rewards'
            element={
              <Venues
                skin={skin}
                accentColor={accentColor}
                fontFamily={fontFamily}
                lang={lang}
              />
            }
          />
        </Routes>
      </NextUIProvider>
    </ChakraProvider>
  )
}

App.defaultProps = {
  env: 'prod',
  accentColor: '#2E58FF',
  lang: 'ES',
  geo: undefined,
  uuid: undefined,
  fiid: undefined,
  fontFamily: 'Poppins',
  gtm: false,
  skin: '',
  searchName: undefined
}

App.propTypes = {
  env: PropTypes.oneOf(['prod', 'dev', 'latest', 'local', 'legacy', 'qa']),
  accentColor: PropTypes.string,
  geo: PropTypes.string,
  uuid: PropTypes.string,
  fiid: PropTypes.string,
  lang: PropTypes.oneOf(['ES', 'EN']),
  fontFamily: PropTypes.oneOf([
    'Poppins',
    'Montserrat',
    'Nunito',
    'DM Sans',
    'Circular Std Book',
    'Avenir',
    'Raleway',
    'Oscine Trial',
    'Ambit',
    'Muli'
  ]),
  gtm: PropTypes.bool,
  skin: PropTypes.oneOf([
    'REWORTH',
    'CLARA',
    'COPPEL',
    'INVEX',
    'UNIQ',
    'SUBURBIA',
    'LIVERPOOL',
    'FINSUS',
    'ALBO'
  ]),
  searchName: PropTypes.string
}

export const ReworthDirectory = ({
  env,
  accentColor,
  lang,
  fontFamily,
  geo,
  uuid,
  fiid,
  gtm,
  skin,
  searchName,
  setSearchName
}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MainContextProvider>
        <App
          env={env}
          accentColor={accentColor}
          lang={lang}
          fontFamily={fontFamily}
          geo={geo}
          fiid={fiid}
          gtm={gtm}
          uuid={uuid}
          searchName={searchName}
          skin={skin}
          setSearchName={setSearchName}
        />
      </MainContextProvider>
    </QueryClientProvider>
  )
}
